// extracted by mini-css-extract-plugin
export default {"sider":"SideBar_sider__dxCAC","logo":"SideBar_logo__yYbfm","logo-img":"SideBar_logo-img__AiYtd"};